export const DOORDASH_DRIVE_DEFAULT_TIP = 20;
